import type { ipcRenderer } from "electron";

declare global {
  interface Window {
    isMainWindow: boolean,
    ipcRenderer: typeof ipcRenderer
  }
}

export enum MessageId {
  ViewToWindow = "view-to-window",
  ViewToWindowReply = "view-to-window-reply",
  ViewToMain = "view-to-main",
  ActivateWindow = "activate-window",
  CloseWindow = "close-window",
  CloseWindowReply = "close-window-reply",
  WindowRectChanged = "window-rect-changed",
  WindowDisplayChanged = "window-display-changed",
  SendWindowId = "send-window-id",
  GetDisplays = "get-displays",
  GetDisplaysReply = "get-displays-reply",
  DisplaysChanged = "displays-changed",
  StoreToMain = "store-to-main",
  StoreToMainReply = "store-to-main-reply",
  StoreToView = "store-to-view",
  SetMainWindowTitle = "set-main-window-title",
  SetWindowTitle = "set-window-title",
  LinkProvisionStart = "link-provision-start",
  LinkProvisionStop = "link-provision-stop",
  LinkProvisionFound = "link-provision-found",
  LinkProvisionError = "link-provision-error",
  LinkProvisionAdd = "link-provision-add",
  LinkProvisionAddReply = "link-provision-add-reply",
  LinkProvisionAddress = "link-provision-address",
  SaveCurrentSessionCookie = "save-current-session-cookie",
  RemoveCurrentSessionCookie = "remove-current-session-cookie",
  JsSolidProtocol = "jssolid-protocol",
}
